import type { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge";

const MIN_PL_VERSION = 124;

/**
 * Checks if the pl-version from swiggyHeaders meets the minimum requirement
 * @param swHeaders - Swiggy headers payload
 * @returns {boolean} true if pl-version exists and is >= MIN_PL_VERSION (124)
 */
export const hasMinimumPlVersion = (swHeaders?: GetSwiggyHeadersResponsePayload): boolean => {
    const plVersion = swHeaders?.["pl-version"];
    if (!plVersion) {
        return false;
    }

    const plVersionNum = Number(plVersion);
    return !Number.isNaN(plVersionNum) && plVersionNum >= MIN_PL_VERSION;
};
